import { useIsMobile } from '@bbl-digital/snorre'
import TopLayoutDesktop from './TopLayoutDesktop'
import TopLayoutMobile from './TopLayoutMobile'
import { navigationBreakpoint } from 'shared/constants/styles'

const TopLayout: React.FC = () => {
  const isMobile = useIsMobile(navigationBreakpoint)

  if (isMobile) {
    return <TopLayoutMobile />
  }

  return <TopLayoutDesktop />
}

export default TopLayout
